<template>
    <UserActivityTile @click="tileClicked()" :userActivity="userActivity">


        <template v-slot:title>{{ userActivity.body.name }}</template>
        <template v-slot:subtitle>{{ userActivity.username }}</template>


        <template v-slot:append-item-right>

            <UserActivityCoinChip>
                {{ $abbreviateNumber(userActivity.body.coinsAmount) }}
            </UserActivityCoinChip>

        </template>

    </UserActivityTile>
</template>



<script lang="ts" setup>

import { useRouter } from 'vue-router';
import { PropType } from 'vue';
import { IInHouseUserActivity } from '@/interfaces/UserActivity/IInHouseUserActivity';

import UserActivityTile from '@/components/Tiles/UserActivity/UserActivityTile.vue';
import UserActivityCoinChip from '@/components/UserActivity/UserActivityTileElements/UserActivityCoinChip.vue';

const props = defineProps({
    userActivity: {
        type: Object as PropType<IInHouseUserActivity>,
        required: true,
    },
});

const router = useRouter();

const tileClicked = () => {
    router.push('/earn');
}

</script>
